import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
// import { Button } from '@mui/material';
import useStyles from './styles';
import { v4 as uuid } from 'uuid';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { DataGrid } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { Container, Chip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { SimpleModal, Icon, TableLoader, ExpandedTooltip } from '@livable/saas-react-components';
export const AppfolioBatchesModal = observer(_ref => {
  let isOpen = _ref.isOpen,
    handleOpen = _ref.handleOpen,
    handleClose = _ref.handleClose,
    propertyId = _ref.propertyId,
    modalData = _ref.modalData;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    glAccounts = _useState2[0],
    setGLAccounts = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    pendingBatches = _useState6[0],
    setPendingBatches = _useState6[1];
  const capitalizeFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  const indicators = /*#__PURE__*/React.createElement("span", {
    className: "indicators"
  }, /*#__PURE__*/React.createElement("span", {
    className: "inline-arrow"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-down"
  })), /*#__PURE__*/React.createElement("span", {
    className: "inline-filter"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "equalizer"
  })));
  const renderHeader = (text, rightAlign) => /*#__PURE__*/React.createElement("span", {
    className: rightAlign ? classes.rightAlign : ''
  }, text, indicators);
  const Cell = _ref2 => {
    let value = _ref2.value,
      _ref2$isStatus = _ref2.isStatus,
      isStatus = _ref2$isStatus === void 0 ? false : _ref2$isStatus;
    return /*#__PURE__*/React.createElement(React.Fragment, null, !isStatus && /*#__PURE__*/React.createElement("span", {
      className: classes.cellContent
    }, value), isStatus && /*#__PURE__*/React.createElement(Chip, {
      label: capitalizeFirstLetter(value),
      variant: value === 'rejected' ? 'critical' : 'success'
    }));
  };
  const DescriptionCell = _ref3 => {
    let value = _ref3.value;
    return /*#__PURE__*/React.createElement(ExpandedTooltip, {
      type: "grey",
      title: value,
      placement: "top"
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.cellDescriptionContent
    }, value));
  };
  let columns = [{
    field: 'unitName',
    align: 'left',
    width: 300,
    valueGetter: v => {
      var _v$row;
      return v === null || v === void 0 || (_v$row = v.row) === null || _v$row === void 0 ? void 0 : _v$row.unitName;
    },
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: params.row.unitName
    }),
    renderHeader: () => renderHeader(t('Unit name'))
  }, {
    field: 'residentName',
    align: 'left',
    width: 200,
    valueGetter: v => {
      var _v$row2, _v$row3;
      return "".concat(v === null || v === void 0 || (_v$row2 = v.row) === null || _v$row2 === void 0 ? void 0 : _v$row2.residentFirstName, " ").concat(v === null || v === void 0 || (_v$row3 = v.row) === null || _v$row3 === void 0 ? void 0 : _v$row3.residentLastName);
    },
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: "".concat(params.row.residentFirstName, " ").concat(params.row.residentLastName)
    }),
    renderHeader: () => renderHeader(t('Resident name'))
  }, {
    field: 'chargedOn',
    align: 'left',
    width: 100,
    valueGetter: v => {
      var _v$row4;
      return v === null || v === void 0 || (_v$row4 = v.row) === null || _v$row4 === void 0 ? void 0 : _v$row4.chargeOn;
    },
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: params.row.chargeOn
    }),
    renderHeader: () => renderHeader(t('Charged on'))
  }, {
    field: 'glAccount',
    align: 'left',
    width: 200,
    valueGetter: v => {
      var _glAccounts$find;
      return (_glAccounts$find = glAccounts.find(i => {
        var _v$row5;
        return i.externalId === (v === null || v === void 0 || (_v$row5 = v.row) === null || _v$row5 === void 0 ? void 0 : _v$row5.glAccountId);
      })) === null || _glAccounts$find === void 0 ? void 0 : _glAccounts$find.name;
    },
    renderCell: params => {
      var _glAccounts$find2;
      return /*#__PURE__*/React.createElement(Cell, {
        value: (_glAccounts$find2 = glAccounts.find(i => i.externalId === params.row.glAccountId)) === null || _glAccounts$find2 === void 0 ? void 0 : _glAccounts$find2.name
      });
    },
    renderHeader: () => renderHeader(t('GL Account'))
  }, {
    field: 'description',
    align: 'left',
    width: 360,
    valueGetter: v => {
      var _v$row6;
      return v === null || v === void 0 || (_v$row6 = v.row) === null || _v$row6 === void 0 ? void 0 : _v$row6.description;
    },
    renderCell: params => /*#__PURE__*/React.createElement(DescriptionCell, {
      value: params.row.description
    }),
    renderHeader: () => renderHeader(t('Description'))
  }, {
    field: 'total',
    align: 'right',
    width: 120,
    valueGetter: v => {
      var _v$row7;
      return +(v === null || v === void 0 || (_v$row7 = v.row) === null || _v$row7 === void 0 ? void 0 : _v$row7.amount);
    },
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: "$".concat(params.row.amount)
    }),
    renderHeader: () => renderHeader(t('Amount'), true)
  }];
  useEffect(() => {
    if (!isOpen) return;
    setIsLoading(true);
    const getPendingBatches = async () => {
      const resp = await store.credentials.getPendingBatchesByIdAsync.run({
        propertyLivableId: propertyId,
        batchExternalId: modalData.externalId
      });
      return resp;
    };
    getPendingBatches().then(async resp => {
      var _resp$response;
      const glAccountsResp = await store.credentials.getGLAccountsAsync.run({
        applyToHomeDashboard: false
      });
      setGLAccounts(glAccountsResp.response);
      setPendingBatches(resp === null || resp === void 0 || (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.charges);
      setIsLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(SimpleModal, {
    subTitle: "Batch type: ".concat(modalData !== null && modalData !== void 0 && modalData.batchType ? capitalizeFirstLetter(modalData === null || modalData === void 0 ? void 0 : modalData.batchType) : ''),
    isOpen: isOpen,
    handleOpen: handleOpen,
    handleClose: handleClose,
    noFooter: true,
    noPadding: true,
    variant: 'large',
    title: /*#__PURE__*/React.createElement("div", {
      className: classes.title
    }, /*#__PURE__*/React.createElement("span", null, "Proposed charges: batch #", modalData === null || modalData === void 0 ? void 0 : modalData.number), /*#__PURE__*/React.createElement(Chip, {
      label: modalData !== null && modalData !== void 0 && modalData.status ? capitalizeFirstLetter(modalData === null || modalData === void 0 ? void 0 : modalData.status) : '',
      variant: (modalData === null || modalData === void 0 ? void 0 : modalData.status) === 'rejected' ? 'critical' : (modalData === null || modalData === void 0 ? void 0 : modalData.status) === 'pending' ? 'warning' : 'success'
    }))
  }, /*#__PURE__*/React.createElement(Container, {
    className: classes.pageContainer
  }, isLoading ? /*#__PURE__*/React.createElement(TableLoader, null) : /*#__PURE__*/React.createElement(DataGrid, {
    getRowId: () => uuid(),
    rows: pendingBatches,
    columns: columns,
    initialState: {
      pagination: {
        paginationModel: {
          pageSize: 25
        }
      }
    },
    pageSizeOptions: [25],
    disableRowSelectionOnClick: true,
    hideFooterSelectedRowCount: true,
    columnHeaderHeight: 48,
    rowHeight: 56
  })));
});